import React from 'react';
import Header from './components/Header';
import QuickContactBar from './components/QuickContactBar'; // Optional
import Hero from './components/Hero';
import Packages from './components/Packages';
import ImageGallery from './components/ImageGallery';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <QuickContactBar /> {/* Optional - Add this line if you want the contact bar */}
      <Header />
      <Hero />
      <Packages />
      <ImageGallery />
      <Footer />
    </div>
  );
}

export default App;